module.exports = __webpack_public_path__ + "static/media/12.8a4a275c.jpg";